// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-banner__content[data-v-3561db82]{padding-bottom:2.34375rem;padding-top:2.34375rem}.blog-banner__content h1[data-v-3561db82]{margin:0 0 .625rem}.blog-banner__content p[data-v-3561db82]{margin:0}.blog-banner__img[data-v-3561db82]{border:1px solid var(--g-color-gray-200);max-width:100%;-o-object-fit:cover;object-fit:cover;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
